import acl from '~/acl.json'
import _get from 'lodash/get'

const can = (profile, ability) => _get(acl, profile.userRole, []).includes(ability)

export default can



// WEBPACK FOOTER //
// ./src/utils/can.js